export function decodeUTF8(s) {
    return decodeURIComponent(escape(s));
}

export function toBase64(str) {
    return btoa(unescape(encodeURIComponent(str)));
}
